// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import { BannerProvider } from './components/BannerContext';
import { PremiumProvider } from './premium/PremiumContext';

// Importa Bootstrap una sola volta
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <PremiumProvider>
      <BannerProvider>
        <App />
      </BannerProvider>
    </PremiumProvider>
  </AuthProvider>
);

reportWebVitals();
